import {Component, Inject, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { ErrorStateMatcher } from '@angular/material/core';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-document-folder-dialog',
  templateUrl: './document-folder-dialog.component.html',
  styleUrls: ['./document-folder-dialog.component.scss']
})
export class DocumentFolderDialogComponent implements OnInit {

  public matcher = new FormErrorStateMatcher();
  
  public entityForm: FormGroup;
  public isEdit: boolean;

  constructor (
    public matDialogRef: MatDialogRef<DocumentFolderDialogComponent>,
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {  }

  ngOnInit () {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
    } else {
      this.isEdit = false
    }
    this.entityForm = this.createForm(this.data)
  }

  createForm (data) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(data.id),
      name: new FormControl(data.name, [ Validators.required ])
    });
    return form
  }
}


